module.exports = __webpack_public_path__ + "img/Nora/Nora-favicon-32x32.png";